import { useCallback } from 'react';
import {
  InformationalScreen,
  ListCard,
  ListItem,
} from '@adc/parallax-component-library';

import { MainContainer, TopHeaderBackArrow } from '~/components/utility';
import { buildTestId } from '~/utilities/buildTestId';
import i18n from '~/utilities/i18n';
import mediator from '~/utilities/mediator';

const consentsItems = [
  {
    text: 'Consents.microcopy.consentsOptions.healthcareCommunications',
    onPress: () => {
      mediator.publish('router:navigate', '/hipaa');
    },
  },
  {
    text: 'Consents.microcopy.consentsOptions.researchConsent',
    onPress: () => {
      mediator.publish('router:navigate', '/rwe');
    },
  },
] as const;

const testID = 'consents';

const ConsentsScreen = () => {
  const handleClickBack = useCallback(() => {
    mediator.publish('router:back');
  }, []);

  return (
    <MainContainer testID={testID}>
      <InformationalScreen
        testID={buildTestId({ testID, suffix: 'screen' })}
        topNavigationProps={{
          title: i18n.t('Consents.title'),
          buttonStart: {
            element: <TopHeaderBackArrow testID="nav-back" />,
            label: 'Go Back',
            onPress: handleClickBack,
          },
          testID: 'nav-back',
        }}
      >
        <InformationalScreen.Page
          testID={buildTestId({ testID, suffix: 'page' })}
        >
          <InformationalScreen.Content>
            <ListCard testID={buildTestId({ testID, suffix: 'list' })}>
              {consentsItems.map((item, index) => (
                <ListItem
                  key={index.toString()}
                  title={i18n.t(item.text)}
                  onPress={item.onPress}
                  testID={buildTestId({
                    testID,
                    suffix: ['list', 'item', index.toString()],
                  })}
                />
              ))}
            </ListCard>
          </InformationalScreen.Content>
        </InformationalScreen.Page>
      </InformationalScreen>
    </MainContainer>
  );
};

export default ConsentsScreen;
